import * as actions from './report.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ReportModel } from '@smarttask-common/src/lib/models/Report/Core/ReportModel';

export const reportAdapter = createEntityAdapter<ReportModel>({
    selectId: (x) => x.report_id,
});
export interface ReportState extends EntityState<ReportModel> {
    selected_report_id: string;
}

export const initialState: ReportState = reportAdapter.getInitialState({
    selected_report_id: undefined,
});

export function ReportReducers(
    state: ReportState = initialState,
    action: actions.ReportActions
) {
    switch (action.type) {
        case actions.ReportActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_report_id: action.selected_report_id };
            return state;

        case actions.ReportActionTypes.ADD_REPORT:
            return reportAdapter.addOne(action.report, state);

        case actions.ReportActionTypes.ADD_REPORTS:
            return reportAdapter.addMany(action.reports, state);

        case actions.ReportActionTypes.UPSERT_REPORT:
            return reportAdapter.upsertOne(action.report, state);

        case actions.ReportActionTypes.UPSERT_REPORTS:
            return reportAdapter.upsertMany(action.reports, state);

        case actions.ReportActionTypes.UPDATE_REPORT:
            return reportAdapter.updateOne(action.report, state);

        case actions.ReportActionTypes.UPDATE_REPORTS:
            return reportAdapter.updateMany(action.reports, state);

        case actions.ReportActionTypes.DELETE_REPORT:
            // if(state.selectedReportId == action.id){
            //   state.selectedReportId = undefined;
            // }
            return reportAdapter.removeOne(action.id, state);

        case actions.ReportActionTypes.DELETE_REPORTS:
            // if(action.ids.indexOf(state.selectedReportId) > -1){
            //   state.selectedReportId = undefined;
            // }
            return reportAdapter.removeMany(action.ids, state);

        case actions.ReportActionTypes.DELETE_ALL_REPORTS:
            return reportAdapter.removeMany(action.ids, state);

        case actions.ReportActionTypes.DELETE_ALL:
            return reportAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getReportState = createFeatureSelector<ReportState>('report');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    reportAdapter.getSelectors(getReportState);

const getSelectedReportIdState = (state: ReportState) => {
    return state.selected_report_id;
};
export const getSelectedReportId = createSelector(getReportState, getSelectedReportIdState);

export const getSelectedReport = createSelector(getReportState, (state: ReportState) => {
    if (state.selected_report_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_report_id];
});
